import axios from "axios";

export const defaultApi = axios.create({
	baseURL: process.env.VUE_APP_API || "/app1-api",
	withCredentials: true,
});

export const authApi = axios.create({
	baseURL: process.env.VUE_APP_AUTH_API || "/auth-api",
	withCredentials: true,
});
